<template>
  <div class="sort-item" @click="handleClick" :class="{active}">
    {{ label }}
    <div class="triangles" v-if="showTriangles">
      <span class="triangle-top" :class="{active: active && sort === 'asc'}" />
      <span class="triangle-bottom" :class="{active: active && sort === 'desc'}" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SortItem',

  props: {
    label: {
      required: true,
      type: String
    },
    value: {
      required: true,
      type: [String, Number]
    },
    showTriangles: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      active: false
    }
  },

  computed: {
    sort() {
      return this.$parent.sort
    }
  },

  methods: {
    handleClick() {
      this.$parent.select(this.value, this.showTriangles)
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-color: #1672fa;
$default-color: #bebebe;

.sort-item {
  line-height: 18px;
  display: inline-flex;
  font-size: 14px;
  margin-left: 40px;
  color: $default-color;
  cursor: pointer;
  user-select: none;
  transition: color ease-in-out 0.3s;
  &:before {
    content: "";
    display: inline-block;
    margin: 3px 4px 0 0;
    border-radius: 5px;
    width: 10px;
    height: 10px;
    background-color: $default-color;
    transition: background-color ease-in-out 0.3s;
  }
  &:hover {
    color: $primary-color;
    &:before {
      background-color: $primary-color;
    }
  }
  &.active {
    color: $primary-color;
    &:before {
      background-color: $primary-color;
    }
  }
}

.triangle-top {
  display: block;
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-bottom: 4px solid $default-color;
  margin-bottom: 2px;
  margin-top: -3px;
  &.active {
    border-bottom-color: $primary-color;
  }
}

.triangles {
  margin: 2px 0 0 10px;
  display: inline-block;
  height: 12px;
  overflow: hidden;
}

.triangle-bottom {
  display: block;
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top: 4px solid $default-color;
  &.active {
    border-top-color: $primary-color;
  }
}
</style>
